export const CardIssuer = {
  Alfbank: "Alfbank",
  AmericanExpress: "AmericanExpress",
  Dankort: "Dankort",
  DinersClub: "DinersClub",
  Discover: "Discover",
  InstaPayment: "InstaPayment",
  InterPayment: "InterPayment",
  Jcb: "Jcb",
  Laser: "Laser",
  Maestro: "Maestro",
  MasterCard: "MasterCard",
  Mir: "Mir",
  Uatp: "Uatp",
  Unionpay: "Unionpay",
  Visa: "Visa",
};
